import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Tooltip } from '@wit-support/ui';
import { CONTENT_CHOICE_REASON_LABEL_RU } from './content-labels.js';
import { CONTENT_CHOICE_REASON_BADGE_VARIANT, CONTENT_LINK_STATUS_HINT_RU, CONTENT_PROBE_OUTCOME_BADGE_VARIANT, CONTENT_PROBE_OUTCOME_LABEL_RU, CONTENT_UNLINKED_LABEL_RU, } from './content-publications-labels.js';
/**
 * Причина выбора первого клипа цветом: сильный — зелёный, рабочий — синий,
 * проба — акцент, закреплён вручную — оранжевый, запасной вариант — серый.
 */
export function ContentReasonBadge({ reason, size, }) {
    return (_jsx(Badge, { variant: CONTENT_CHOICE_REASON_BADGE_VARIANT[reason], "data-reason": reason, ...(size ? { size } : {}), children: CONTENT_CHOICE_REASON_LABEL_RU[reason] }));
}
/**
 * «не связано» — публикация ещё не связана с постом в сети. Причина движка
 * (`linkReason`, строка как есть) — в подсказке кита (фокус с клавиатуры);
 * без неё — пояснение по статусу.
 */
export function ContentUnlinkedBadge({ status, reason, }) {
    const hint = reason ?? CONTENT_LINK_STATUS_HINT_RU[status ?? 'pending'];
    return (_jsx(Tooltip.Provider, { children: _jsxs(Tooltip.Root, { children: [_jsx(Tooltip.Trigger, { asChild: true, children: _jsx(Badge, { variant: status === 'failed' ? 'warning' : 'outline', tabIndex: 0, "data-link-status": status ?? 'pending', children: CONTENT_UNLINKED_LABEL_RU }) }), _jsx(Tooltip.Content, { children: hint })] }) }));
}
/** Итог пробы нового клипа: залёт — зелёный, ниже обычного — красный. */
export function ContentProbeOutcomeBadge({ outcome }) {
    return (_jsx(Badge, { variant: CONTENT_PROBE_OUTCOME_BADGE_VARIANT[outcome], "data-outcome": outcome, children: CONTENT_PROBE_OUTCOME_LABEL_RU[outcome] }));
}
//# sourceMappingURL=content-publications-badges.js.map